import { FC, memo, useCallback } from "react";
import { InvestmentTitle } from "../investment-title";
import { ReactComponent as LampSvg } from "assets/lamp.svg";
import { InvestmentList } from "../investment-list";
import { InvestmentBox } from "../investment-box";
import { useTranslate } from "@tolgee/react";
import { Videos } from "new-architecture/components/videos";
import { useTrackTeaserProductVideoOpenedMutation } from "api/analitics";
import { PropertyTeaserType } from "store/properties/types";

import styles from "./style.module.scss";

interface InvestmentStrategyProps {
  values: Array<string>;
  videos: Array<string>;
  property: PropertyTeaserType
}

export const InvestmentStrategy: FC<InvestmentStrategyProps> = memo(({ values, videos, property }) => {
  const { t: tOpportunityDetailPageInvest } = useTranslate('opportunity_detail_page.investment');

  const [trackProductVideoOpened] = useTrackTeaserProductVideoOpenedMutation();
  const onOpenVideo = useCallback((videoUrl: string) => {
    trackProductVideoOpened({
      opportunity: property.name,
      opportunityId: property._id,
      productVideoUrl: videoUrl
    });
  }, [trackProductVideoOpened, property]);

  return (
    <InvestmentBox>
      <InvestmentTitle title={tOpportunityDetailPageInvest('opportunity_detail_page.investment.investment_title')} icon={<LampSvg />} />
      <Videos videos={videos} onOpenVideo={onOpenVideo} />
      <div className={styles.strategy__subcontainer}>
        <div className={styles.strategy__subheader}>
          {tOpportunityDetailPageInvest('opportunity_detail_page.investment.subheader_strategy')}
        </div>
        <div className={styles["strategy__list-container"]}>
          <InvestmentList list={values} />
        </div>
      </div>
    </InvestmentBox>
  );
});

InvestmentStrategy.displayName = "InvestmentStrategy";
